export default {

    state: {
        pagination: []
    },

    getters: {
        pagination(state) {
            return state.pagination
        }
    },

    mutations: {
        SET_PAGINATION(state, pages) {
            state.pagination = pages
        }
    },

    actions: {
        CREATE_PAGINATION(context, pageCount) {
            var pages = Array.from(new Array(pageCount), (val, index) => index + 1);
            context.commit('SET_PAGINATION', pages)
        },
        CLEAR_PAGINATION(context) {
            context.commit('SET_PAGINATION', [])
        }
    }

}